var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgCap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 11,
    fill: "#7E9414"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.44141 8.2211C5.44141 7.86028 5.58474 7.51425 5.83987 7.25912C6.095 7.00399 6.44103 6.86066 6.80184 6.86066H14.9645C15.3253 6.86066 15.6713 7.00399 15.9265 7.25912C16.1816 7.51425 16.3249 7.86028 16.3249 8.2211V15.0233C16.3249 15.3841 16.1816 15.7301 15.9265 15.9853C15.6713 16.2404 15.3253 16.3837 14.9645 16.3837H6.80184C6.44103 16.3837 6.095 16.2404 5.83987 15.9853C5.58474 15.7301 5.44141 15.3841 5.44141 15.0233V8.2211ZM6.12163 14.3431V15.0233C6.12163 15.2037 6.19329 15.3767 6.32086 15.5043C6.44842 15.6318 6.62144 15.7035 6.80184 15.7035H14.9645C15.1449 15.7035 15.3179 15.6318 15.4455 15.5043C15.573 15.3767 15.6447 15.2037 15.6447 15.0233V12.6425L13.0755 11.3181C13.0117 11.2862 12.9395 11.2751 12.8691 11.2864C12.7986 11.2978 12.7335 11.331 12.683 11.3814L10.1594 13.905L8.35002 12.6997C8.2847 12.6562 8.20634 12.6366 8.12823 12.6443C8.05013 12.652 7.97708 12.6864 7.92149 12.7418L6.12163 14.3431ZM9.52272 9.92164C9.52272 9.65104 9.41522 9.39151 9.22387 9.20016C9.03253 9.00881 8.773 8.90131 8.50239 8.90131C8.23178 8.90131 7.97226 9.00881 7.78091 9.20016C7.58956 9.39151 7.48206 9.65104 7.48206 9.92164C7.48206 10.1923 7.58956 10.4518 7.78091 10.6431C7.97226 10.8345 8.23178 10.942 8.50239 10.942C8.773 10.942 9.03253 10.8345 9.22387 10.6431C9.41522 10.4518 9.52272 10.1923 9.52272 9.92164Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgCap);
export default __webpack_public_path__ + "static/media/img-cap.2e338d2e39a0031b46be1fb5a9e14656.svg";
export { ForwardRef as ReactComponent };